import React from 'react';
import { IonPage } from '@ionic/react';
import AppHeader from './AppHeader';

interface PageLayoutProps {
  children: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children }) => (
  <IonPage>
    <AppHeader />
    {children}
  </IonPage>
);

export default PageLayout;
